import { gql } from '@apollo/client';

export const SEARCH_SHUTTLE_SERVICE_PROVIDER = gql`
  query SearchShuttleServiceProvider($page: PageInput!, $isactive: Boolean, $countryCode: CountryCode, $name: String, $searchShuttleServiceProviderId: String) {
    searchShuttleServiceProvider(page: $page, isactive: $isactive, country_code: $countryCode, name: $name, id: $searchShuttleServiceProviderId) {
      code
      success
      message
      total_count
      providers {
        provider_id
        provider_name
        service_description {
          en
          ar
        }
        contact {
          person
          mobile_number
          email
          address
        }
        country_code
        price {
          base
          tax
          gross
          currency
        }
        isactive
        user_audit {
          created_by
          created_date
          modified_by
          modified_date
        }
      }
    }
  }
`;

export const GET_SHUTTLE_SERVICE_DETAILS = gql`
  query searchShuttleServiceProvider($searchShuttleServiceProviderId: String, $page: PageInput!) {
    searchShuttleServiceProvider(id: $searchShuttleServiceProviderId, page: $page) { 
      code
      success
      message
      providers {
        provider_id
        provider_name
        service_description {
          en
          ar
        }
        contact {
          person
          mobile_number
          email
          address
        }
        country_code
        price {
          base
          tax
          gross
          currency
        }
        isactive
        user_audit {
          created_by
          created_date
          modified_by
          modified_date
        }
      }   
    } 
  }
`;

export const GET_ROUTE_SHUTTLE_SERVICES = gql`
  query GetShuttleDetailsFromRouteByRouteId($route_id: NonEmptyString!, $page: PageInput!) {
    getShuttleDetailsFromRouteByRouteId(route_id: $route_id, page: $page) {
      code
      success
      message
      route_shuttles {
        route_shuttle_id
        route_id
        shuttle_provider {
          provider_id
          provider_name
          service_description {
            en
            ar
          }
          contact {
            person
            mobile_number
            email
            address
          }
          country_code
          price {
            base
            tax
            gross
            currency
          }
          isactive
          user_audit {
            created_by
            created_date
            modified_by
            modified_date
          }
        }
      }
    }
  }
`;
